<script setup lang="ts">

import { usePresentation } from '../Types';

const presentation = usePresentation();

</script>

<template>

    <div class="flex flex-col w-full h-full grow
                justify-center items-center tracking-wider"
         :class="presentation.isTabletMode ? 'px-10' : 'px-6 md:px-10 lg:px-24'">

        <slot />

    </div>

</template>